export default "__VITE_ASSET__CqQmH00O__"